export default "__VITE_ASSET__CyOMuGGo__"